import { render, staticRenderFns } from "./EnIyiSatilanUrunlarDonut.vue?vue&type=template&id=0c223e02&scoped=true"
import script from "./EnIyiSatilanUrunlarDonut.vue?vue&type=script&lang=js"
export * from "./EnIyiSatilanUrunlarDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c223e02",
  null
  
)

export default component.exports